module.exports = __webpack_public_path__ + "img/lunbo201.0226e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo201.png
// module id = ok6H
// module chunks = 0